export default function notificationComponent() {
    return {
        notifications: [],
        totalCount: 0,
        unreadCount: 0,
        initialize() {

            console.log("Listening for events...");

            // Listen for the public notification on the 'public.notifications' channel
            window.Echo.channel('public.notifications').listen('.public.notification', (response) => {
                this.notifications.push({ id: response.id, message: response.title });
                this.totalCount += 1;
                this.unreadCount += 1;
            });

            if (window.userID === null) {
                return;
            }

            window.Echo.private(`App.User.${window.userID}`).listen('.private.notification', (response) => {

                this.notifications.unshift({
                    id: response.notification.id,
                    title: response.notification.title,
                    body: response.notification.body,
                    filePath: response.notification.filePath
                });
                this.totalCount += 1;
                this.unreadCount += 1;
            });
        },

        async fetchNotifications() {
            try {
                const csrfToken = document.querySelector('meta[name="_token"]')?.getAttribute('content');

                // Add timeout and retry logic
                const controller = new AbortController();
                setTimeout(() => controller.abort(), 10000); // 10 second timeout

                const response = await fetch('/api/notifications', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': csrfToken || '',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'same-origin',
                    signal: controller.signal
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                this.notifications = data.notifications;
                this.unreadCount = data.unreadCount;
                this.totalCount = data.totalCount;

                console.log('✅ Notifications loaded successfully');

            } catch (error) {
                console.error('Error fetching notifications:', error);

                // Handle specific error types
                if (error.name === 'AbortError') {
                    console.error('⏱️ Request timed out - server may be overloaded');
                } else if (error.message.includes('ERR_CONNECTION_CLOSED')) {
                    console.error('🔌 Connection was closed - server may be restarting');
                    // Retry after a delay
                    setTimeout(() => {
                        console.log('🔄 Retrying notifications fetch...');
                        this.fetchNotifications();
                    }, 5000);
                    return; // Don't initialize Echo if connection failed
                } else if (error.message.includes('Failed to fetch')) {
                    console.error('🌐 Network error - check your internet connection');
                }

                // Set empty state for failed requests
                this.notifications = [];
                this.unreadCount = 0;
                this.totalCount = 0;
            }

            this.initialize();
        },
        getDownloadUrl(payload) {
            try {
                const parsed = JSON.parse(payload);
                return parsed?.filePath ? '/general-export/download/order-sheet?fileName=' + parsed?.filePath : '';
            } catch (error) {
                console.error('Error parsing payload:', error);
            }
            return '';
        },
        handleNotificationClick(notification) {
            axios.post(`/api/notifications/${notification.id}/is-read`)
                .then(response => {
                    this.unreadCount -= 1;
                    notification.is_verify = 0;
                    console.log(response.data.message);
                })
                .catch(error => {
                    console.error('Failed to mark notification as read:', error);
                    // Optionally, you can add logic to handle errors here
                });
        }
    }
}
